import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './dashboard.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

type DashboardItem = {
  image: string;
  caption: string;
  url: string;
};

type DashboardItems = {
  tiles: DashboardItem[];
  features: DashboardItem[];
};

export default function Dashboard() {
  const [data, setData] = useState<DashboardItems>({ tiles: [], features: [] });

  useEffect(() => {
    fetch(`${publicUrl}/assets/dashboard.json`)
      .then((response) => response.json())
      .then((dashboardData) => {
        if (!dashboardData) throw new Error(`Exception: Can't parse "dashboard.json" file`);
        setData(dashboardData);
      })
      .catch((error) => {
        throw new Error(`Exception: Can't read "dashboard.json" file: ${error}`);
      });
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.tiles}>
        {data.tiles.map((item, index) => (
          <Link key={`DashboardTileItem_${index}`} to={`${publicUrl}${item.url}`} className={styles.tile}>
            <div style={{ backgroundImage: `url(${publicUrl}/${item.image})` }} className={styles.preview} />
            <div className={styles.caption}>{item.caption}</div>
          </Link>
        ))}
      </div>
      <div className={styles.features}>
        <h3 className={styles.header}>Popular Features</h3>
        {data.features.map((item, index) => (
          <Link key={`DashboardFeatureItem_${index}`} to={`${publicUrl}${item.url}`} className={styles.feature}>
            <div style={{ backgroundImage: `url(${publicUrl}/${item.image})` }} className={styles.icon} />
            <div className={styles.label}>{item.caption}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
